import { connect } from 'react-redux';
import { isAuthorised } from '../../../../../store/general/selectors';
import { IState } from '../../../../../store/types';
import { getAudioById, getNativeLanguage, isUserGroupsLoaded } from '../../../../../store/models/selectors';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { getTargetCaptionTexts } from '../../../../../store/videos/selectors';
import { getAudioWords, getWordsLemmas, isWordsGenerating, isWordsLemmasLoading, isWordsLoadFailed, isWordsGenerateFailed, getWordsNative, isWordsNativeFor } from '../../../../../store/words/selectors';
import { hasUsableTranscript } from '../../../../../../common/utils/audioTranscriptUtil';
import { EMPTY_ARRAY } from '../../../../../../common/types';
import { WordsTab } from '../components/WordsTab';
import { IWordsTabEvents, IWordsTabFields } from '../components/types';
import { WordsTabEvents } from './events';

const mapStateToProps = (
	state: IState
): IWordsTabFields => {
	const audioId = getCurrentAudioId(state);
	const audio = audioId ? getAudioById(state, audioId) : undefined;
	const data = audioId ? getAudioWords(state, audioId) : undefined;
	const words = data?.words || EMPTY_ARRAY;
	const nativeLangCode = getNativeLanguage(state)?.code;
	const native = audioId ? getWordsNative(state, audioId) : undefined;
	const nativeRequested = isWordsNativeFor(native, words, nativeLangCode);
	return {
		// only once the user is in the store too — REST calls reject before that
		audioId: audioId && isAuthorised(state) ? audioId : undefined,
		audioLoaded: !!audio || isUserGroupsLoaded(state),
		hasTranscript: hasUsableTranscript(audio),
		langCode: audio?.language?.code,
		loaded: !!data,
		loadFailed: audioId ? isWordsLoadFailed(state, audioId) : false,
		words: words,
		canRegenerate: !!data?.canRegenerate,
		generating: audioId ? isWordsGenerating(state, audioId) : false,
		generateFailed: audioId ? isWordsGenerateFailed(state, audioId) : false,
		captionTexts: getTargetCaptionTexts(state),
		lemmas: getWordsLemmas(state, audio?.language?.code),
		lemmasLoading: isWordsLemmasLoading(state, audio?.language?.code),
		nativeLangCode,
		nativeRequested,
		nativeLoading: nativeRequested && native?.items === null,
		wordsNative: nativeRequested ? native?.items || undefined : undefined,
	};
}

const mapDispatchToProps = (
	dispatch: any
): IWordsTabEvents => ({
	onLoad: () => dispatch(WordsTabEvents.onLoad()),
	onLoadLemmas: (words) => dispatch(WordsTabEvents.onLoadLemmas(words)),
	onGenerate: () => dispatch(WordsTabEvents.onGenerate()),
	onLoadNative: () => dispatch(WordsTabEvents.onLoadNative()),
});

export const WordsTabHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(WordsTab);

WordsTabHOC.displayName = 'WordsTabHOC';
